import { DraftConfigurationTextStyle } from '@/types';
import { coordinatesForText } from '@/utils/text/coordinatesForText';

// Update text style offset to match the text alignment
export const adjustTextStyleOffset = (textStyle: DraftConfigurationTextStyle, text: string) => {
  const { x, y } = coordinatesForText({ style: textStyle, content: text });
  textStyle.x = x;
  textStyle.y = y;
};
